<div fxLayout="row" fxFlex="100">
  <select-with-search
    [appearance]="appearance"
    [items]="maintenanceTypes"
    [appearance]="appearance"
    [disabled]="disabled"
    [required]="required"
    [formControl]="fromControl"
    [fxFlex]="100"
    fieldDisplayedInMatOption="name"
    [archivedLabel]="'MAINTENANCE_TYPE_INPUT.ARCHIVED' | translate"
    [floatLabel]="'MAINTENANCE_TYPE_INPUT.TITLE' | translate"
    [searchLabel]="'MAINTENANCE_TYPE_INPUT.SEARCH_MAINTENANCES_TYPES' | translate"
    [noItemsFoundMessage]="'MAINTENANCE_TYPE_INPUT.MAINTENANCES_TYPES_NOT_FOUND' | translate"
    [errorMessageRequired]="'MAINTENANCE_TYPE_INPUT.ERRORS.MAINTENANCES_TYPES_REQUIRED' | translate"
  >
  </select-with-search>
</div>
